export default __webpack_public_path__ + "static/media/book-cover.38d9e61a.png";